/* eslint-disable react/jsx-key */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-shadow */
/* eslint-disable import/no-unresolved */
import React, { Fragment, useState } from 'react';
import { Button, ButtonGroup, Dialog, Loading, Tab } from '@/components';
import { Container, FormGroup } from 'reactstrap';
import Event from '@/model/Event';
import { FormData, FormErrors, OnChangeFormInput } from '@/hooks';
import { CloneProductScreen } from '@/features/registerEvent/components/CloneProduct';
import { SectorProductComboScreen } from '@/features/registerEvent/components/SectorProductCombo/screens';
import { SectorProductGroupScreen } from '@/features/registerEvent/components/SectorProductGroup/screens';
import { SectorProductScreen } from '@/features/registerEvent/components/SectorProductScreen/screens';
import { SectorProductConfigSectorScreen } from '@/features/registerEvent/components/SectorProductConfigSectorSreen/screens';
import { SectorPosScreen } from '@/features/registerEvent/components/SectorPosScreen/screens';
import { toast } from 'react-toastify';
import EventPhaseCompletion from '@/model/EventPhaseCompletion';
import { ActionProps } from '@/components/Dialog';
import { ProducerProductLinkScreen } from '@/features/registerEvent/components/ProducerProductLink';
import { ProducerLink, ProducerSectionLink } from '@/model/ProducerLink';
import { CopyProducerProductLinkScreen } from '@/features/registerEvent/components/CopyProducerProductLink';
import { FiCopy } from 'react-icons/fi';
import { formSectorProductProps, ShouldShowModal } from '../types';
import { controllerEventProps } from '../../SectorTicket/types';

// eslint-disable-next-line no-shadow
export enum States {
  default = 'default',
  loading = 'loading',
}

export interface SectorProductContainerProps {
  state: States;
  formSectorProduct: formSectorProductProps;
  controllerEvent: controllerEventProps;
  phaseCompletion: EventPhaseCompletion | undefined;
  eventChild: Event[];
  formDataCloneProduct: FormData;
  formErrorsCloneProduct: FormErrors;
  onChangeFormCloneProduct: OnChangeFormInput;
  openProducerLinkModal: () => void;
  openProducerLinksModal: () => void;
  formDataProducerProductLink: FormData;
  formErrorsProducerProductLink: FormErrors;
  onChangeFormProducerProductLink: OnChangeFormInput;
  onHandleHasProduct: (b: string) => void;
  handleGetEventPhaseCompletion: () => void;
  cloneProducts: () => void;
  onCloneProducts: () => void;
  title: React.ReactNode;
  visible: boolean;
  shouldShowModal: ShouldShowModal;
  onToggle: () => void;
  producerLink?: ProducerLink;
  producerLinks: ProducerSectionLink[];
  onGenerateProducerLink: () => void;
  onCopyLink: (url: string) => void;
}

// eslint-disable-next-line no-shadow
export enum FormInputName {
  isProduct = 'isProduct',
}

export type TabSectorProductActionsProps = {
  nextTab: () => void;
  backTab: () => void;
  onFirstTab: () => void;
  controllerEvent: controllerEventProps;
  phaseCompletion?: EventPhaseCompletion | undefined;
  handleGetEventPhaseCompletion: () => void;
};

export const SectorProductContainer: React.FC<SectorProductContainerProps> = ({
  state,
  formSectorProduct,
  controllerEvent,
  phaseCompletion,
  title,
  visible,
  shouldShowModal,
  eventChild,
  formDataCloneProduct,
  formErrorsCloneProduct,
  onChangeFormCloneProduct,
  cloneProducts,
  onCloneProducts,
  openProducerLinkModal,
  openProducerLinksModal,
  formDataProducerProductLink,
  formErrorsProducerProductLink,
  onChangeFormProducerProductLink,
  onGenerateProducerLink,
  onHandleHasProduct,
  handleGetEventPhaseCompletion,
  onToggle,
  producerLink,
  producerLinks,
  onCopyLink,
}) => {
  const renderActionDialogToCancel: ActionProps = {
    title: 'Cancelar',
    onClick: (): void => onToggle(),
    theme: 'noneBorder',
  };

  const { formData, formErrors, onChangeFormInput } = formSectorProduct;
  const [numberTab, setNumberTab] = useState(0);

  const { eventState, onChangeEvent, lastStep } = controllerEvent;

  const handleNextTab = (): void => {
    if (numberTab <= contentTabs.length) {
      setNumberTab(numberTab + 1);
    }
  };

  const handleBackTab = (): void => {
    if (numberTab <= contentTabs.length && numberTab >= 0) {
      setNumberTab(numberTab - 1);
    }
  };

  const handleOnFirstTab = (): void => {
    setNumberTab(0);
  };

  const contentTabs = [
    {
      component: (
        <SectorProductGroupScreen
          handleGetEventPhaseCompletion={handleGetEventPhaseCompletion}
          nextTab={handleNextTab}
          controllerEvent={controllerEvent}
        />
      ),
      completion: !!phaseCompletion?.sectionProduct?.group,
      title: 'Cadastro de grupos',
    },
    {
      component: (
        <SectorProductScreen
          handleGetEventPhaseCompletion={handleGetEventPhaseCompletion}
          controllerEvent={controllerEvent}
          nextTab={handleNextTab}
          backTab={handleBackTab}
          onFirstTab={handleOnFirstTab}
        />
      ),
      completion: !!phaseCompletion?.sectionProduct?.product,
      title: 'Cadastro de produtos',
    },
    {
      component: (
        <SectorProductComboScreen
          nextTab={handleNextTab}
          backTab={handleBackTab}
          onFirstTab={handleOnFirstTab}
          controllerEvent={controllerEvent}
          phaseCompletion={phaseCompletion}
          handleGetEventPhaseCompletion={handleGetEventPhaseCompletion}
        />
      ),
      completion: !!phaseCompletion?.sectionProduct?.combo,
      title: 'Cadastro de combos',
    },
    {
      component: (
        <SectorProductConfigSectorScreen
          handleGetEventPhaseCompletion={handleGetEventPhaseCompletion}
          nextTab={handleNextTab}
          backTab={handleBackTab}
          numberTab={numberTab}
        />
      ),
      completion: !!phaseCompletion?.sectionProduct?.section,
      title: 'Configs de setores',
    },
    {
      component: (
        <SectorPosScreen
          numberTab={numberTab}
          nextTab={handleNextTab}
          backTab={handleBackTab}
          phaseCompletion={phaseCompletion}
          handleGetEventPhaseCompletion={handleGetEventPhaseCompletion}
        />
      ),
      completion: !!phaseCompletion?.sectionProduct?.pos,
      title: 'Configurações de POS',
    },
  ];
  return (
    <Fragment>
      <Loading isVisible={state === States.loading} />
      <Container className="mainContainer" fluid={true}>
        <div className="container-event">
          <h5 className="mb-2 border-bottom-title mb-5">Setor e Produto</h5>
        </div>
        <FormGroup className="mb-2">
          <ButtonGroup
            label="Este evento terá produtos?"
            name="isProduct"
            value={formData[FormInputName.isProduct]}
            onChange={e => {
              onHandleHasProduct(e.target.value);
              onChangeFormInput(FormInputName.isProduct)(e.target.value);
            }}
            options={[
              { value: true, label: 'Sim' },
              { value: false, label: 'Não' },
            ]}
            error={formErrors.isProduct && formErrors.isProduct[0]}
          />
        </FormGroup>

        <hr className="mt-5" />
        <div className="mt-4 mb-5">
          <p className="secondPageTitle mb-1">Ações</p>
          <span className="infoSubTitle">Gerencie produtos e links deste evento.</span>
          <div className="d-flex flex-wrap align-items-center mt-3" style={{ gap: '12px' }}>
            <Button
              title="Clonar produtos"
              theme="outlineDark"
              onClick={() => {
                onChangeEvent(cloneProducts());
              }}
            />
            <Button title="Criar link" theme="dark" onClick={openProducerLinkModal} />
            {producerLinks.length > 0 && (
              <Button title="Ver links" theme="outlineDark" onClick={openProducerLinksModal} />
            )}
          </div>
        </div>

        {formData[FormInputName.isProduct] === 'true' && (
          <>
            <div className="mt-5 mb-4">
              <p className="secondPageTitle m-0">Adicionando setor e produto</p>
              <span className="infoSubTitle mb-3">
                Preencha as 5 (CINCO) etapas abaixo para adicionar um setor e produto
              </span>
            </div>

            <Tab contents={contentTabs} numberStap={numberTab} />
          </>
        )}
        <div className="footer-register-event">
          <Button
            title="Voltar"
            theme="noneBorder"
            onClick={() => {
              onChangeEvent({ ...eventState, currentStep: eventState.currentStep - 1 });
            }}
          />
          {numberTab === 4 || formData[FormInputName.isProduct] === 'false' ? (
            <Button
              title="Avançar para PDV"
              onClick={() => {
                if (
                  formData[FormInputName.isProduct] === 'false' ||
                  (lastStep && lastStep.length > 0)
                ) {
                  onChangeEvent({ ...eventState, currentStep: eventState.currentStep + 1 });
                } else {
                  toast.error('Preencha todas as etapas para avançar para o próximo passo');
                }
              }}
            />
          ) : null}
        </div>
        <Dialog
          title={title}
          visible={visible}
          onClose={onToggle}
          actions={[
            {
              [ShouldShowModal.cloneProduct]: renderActionDialogToCancel,
              [ShouldShowModal.producerLink]: renderActionDialogToCancel,
              [ShouldShowModal.copyProducerLink]: renderActionDialogToCancel,
              [ShouldShowModal.producerLinks]: renderActionDialogToCancel,
            }[shouldShowModal],
            {
              [ShouldShowModal.cloneProduct]: {
                title: 'Clonar',
                onClick: () => {
                  onCloneProducts();
                },
              },
              [ShouldShowModal.producerLink]: {
                title: 'Gerar Link',
                onClick: () => onGenerateProducerLink(),
              },
              [ShouldShowModal.copyProducerLink]: {
                title: undefined,
              },
              [ShouldShowModal.producerLinks]: {
                title: undefined,
              },
            }[shouldShowModal],
          ]}
        >
          {
            {
              [ShouldShowModal.cloneProduct]: (
                <CloneProductScreen
                  eventChild={eventChild}
                  formData={formDataCloneProduct}
                  formErrors={formErrorsCloneProduct}
                  onChangeFormInput={onChangeFormCloneProduct}
                />
              ),
              [ShouldShowModal.producerLink]: (
                <ProducerProductLinkScreen
                  formData={formDataProducerProductLink}
                  formErrors={formErrorsProducerProductLink}
                  onChangeFormInput={onChangeFormProducerProductLink}
                />
              ),
              [ShouldShowModal.copyProducerLink]: (
                <CopyProducerProductLinkScreen
                  producerLink={producerLink}
                  onCopyLink={onCopyLink}
                />
              ),
              [ShouldShowModal.producerLinks]: (
                <div className="filter-modal-content">
                  <p className="mb-3 text-muted">Clique no ícone para copiar o link do setor.</p>
                  <div className="d-flex flex-column" style={{ gap: '10px' }}>
                    {producerLinks.map(link => (
                      <div
                        key={link.url}
                        className="d-flex align-items-center justify-content-between border rounded p-3"
                      >
                        <span className="font-weight-bold">{link.sectionName}</span>
                        <button
                          type="button"
                          className="btn button-none-border button-sm"
                          title={`Copiar link do setor ${link.sectionName}`}
                          aria-label={`Copiar link do setor ${link.sectionName}`}
                          onClick={() => onCopyLink(link.url)}
                        >
                          <FiCopy size={20} />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              ),
            }[shouldShowModal]
          }
        </Dialog>
      </Container>
    </Fragment>
  );
};
